import { SchmancyElement } from '@schmancy/mixins/index'
import { css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

/**
 * Uses the WCAG clip pattern, not `display:none`/`visibility:hidden`, so
 * assistive tech still reads content hidden from sighted users.
 */
@customElement('schmancy-visually-hidden')
export class SchmancyVisuallyHidden extends SchmancyElement {
	static styles = [
		css`
			:host {
				position: absolute;
				width: 1px;
				height: 1px;
				padding: 0;
				margin: -1px;
				overflow: hidden;
				clip: rect(0, 0, 0, 0);
				white-space: nowrap;
				border-width: 0;
			}
		`,
	]
	render() {
		return html`<slot></slot>`
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-visually-hidden': SchmancyVisuallyHidden
	}
}
